/* global axios */
import ApiClient from '../ApiClient';

class CaptainTestRuns extends ApiClient {
  constructor() {
    super('captain/test_runs', { accountScoped: true });
  }

  get({ assistantId, status } = {}) {
    return axios.get(this.url, {
      params: { assistant_id: assistantId, status },
    });
  }

  update(id, attributes) {
    return axios.patch(`${this.url}/${id}`, { test_run: attributes });
  }
}

export default new CaptainTestRuns();
